import React from "react";
import { Box } from "@mui/material";
import { AuthView } from "./components/AuthView";
import { useGetAnalyticsPropertiesQuery } from "../../../../../../shell/services/analytics";
import SinglePageAnalytics from "./views/SinglePageAnalytics";
import AnalyticsDashboard from "./views/AnalyticsDashboard";
import { ContentItem } from "../../../../../../shell/services/types";
import { useGetInstanceSettingsQuery } from "../../../../../../shell/services/instance";
import { PropertiesDialog } from "./components/PropertiesDialog";
import { useHistory } from "react-router";
type Props = {
  item?: ContentItem;
};
const Analytics = ({
  item
}: Props) => {
  const history = useHistory();
  const {
    isFetching,
    isError,
    refetch
  } = useGetAnalyticsPropertiesQuery();
  const {
    data: instanceSettings,
    isFetching: instanceSettingsFetching
  } = useGetInstanceSettingsQuery();
  const propertyId = instanceSettings?.find(setting => setting.key === "google_property_id")?.value;
  const validateAuth = () => {
    refetch();
  };
  return <Box sx={{
    boxSizing: "border-box",
    color: theme => theme.palette.text.primary
  }} height={"100%"} overflow="auto" bgcolor="grey.50" data-sentry-element="Box" data-sentry-component="Analytics" data-sentry-source-file="index.tsx">
      {!isError ? <>
          {item ? <Box px={4} py={2.5}>
              <SinglePageAnalytics item={item} loading={isFetching} />
            </Box> : <AnalyticsDashboard loading={isFetching} />}
          {!instanceSettingsFetching && !propertyId && !isFetching && <PropertiesDialog onClose={(shouldNavAway = false) => {
        if (shouldNavAway && item) {
          history.push(`/content/${item?.meta?.contentModelZUID}/${item?.meta?.ZUID}`);
        }
        if (shouldNavAway && !item) {
          history.push(`/launchpad`);
        }
      }} />}
        </> : <Box px={4} height="100%">
          <AuthView validateAuth={validateAuth} isDashboard={!item} />
        </Box>}
    </Box>;
};
export default Analytics;